module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/328.8e70af0f.png";